<template>
  <div class="main">
    <div v-if="step==='history'" class="systemUpgrade">
      <div class="systemUpgrade-main">
        <module-title :title="`${historyRecordPrpos.campusAppName}${historyRecordPrpos.versionCode}--历史记录`">
          <div class="right">
            <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="$emit('back')">
              返回
            </el-button>
          </div>
        </module-title>
        <SearchForm :history-type="historyRecordPrpos.upgradeType" @handleSearchFilter="handleSearchFilter" @resetInput="resetInput" />
        <div class="systemUpgrade-main-contain">
          <div class="tip">
            总共待更新设备数：<strong>{{ statisticalData.totalCount }}</strong>
          </div>
          <el-table
            v-loading="listLoading"
            :data="applicationList"
            highlight-current-row
            fit
            element-loading-text="Loading"
            class="list-table"
            :span-method="objectSpanMethod"
            border=""
          >
            <el-table-column label="序号" type="index" align="center" width="55" />
            <el-table-column label="区域" prop="areaName" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.provinceName }}/{{ scope.row.cityName }}/{{ scope.row.areaName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="学校" prop="schoolName" align="center" />
            <el-table-column v-if="historyRecordPrpos.upgradeType===2" label="楼栋" prop="buildingName" align="center" />
            <el-table-column v-if="historyRecordPrpos.upgradeType===2" label="教室号" prop="roomName" align="center" />
            <el-table-column v-if="historyRecordPrpos.upgradeType===1" label="年级" prop="gradeName" align="center" />
            <el-table-column v-if="historyRecordPrpos.upgradeType===1" label="班级" prop="className" align="center" />
            <el-table-column label="发布时间" prop="releaseDate" align="center" />
            <el-table-column label="已绑设备数" prop="totalCount" align="center" />
            <el-table-column label="已更新数" prop="upgradeSuccessCount" align="center" />
            <el-table-column label="未更新数" prop="unupgradeCount" align="center">
              <template slot-scope="scope">
                <span class="sign" @click="handleUpdateNum(2,scope.row)">{{ scope.row.unupgradeCount }}</span>
              </template>
            </el-table-column>
            <el-table-column label="更新失败数" prop="updateFailNum" align="center">
              <template slot-scope="scope">
                <span class="sign" @click="handleUpdateNum(1,scope.row)">{{ scope.row.upgradeFailureCount }}</span>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="searchForm.total"
            :page.sync="searchForm.pageNum"
            :limit.sync="searchForm.pageSize"
            @pagination="pageCurriculumList"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <UpdateSituation v-else :type-code="typeCode" :update-record-prpos="updateRecordPrpos" :update-status="updateStatus" @back="back" />
  </div>
</template>

<script>

import { formatTimeToStr } from '@/utils/index';
import {
  campusVersionsReleaseStatisticPage,
  campusVersionsReleaseStatistic
} from '@/api/systemMaintenance/upgradeManage/versionManage';
import SearchForm from './searchForm.vue';
import UpdateSituation from './updateSituation.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'AppHistoryRecord',
  components: {
    SearchForm,
    UpdateSituation
  },
  props: {
    historyRecordPrpos: {
      type: Object,
      required: true
    },
    typeCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      step: 'history',
      // 搜索表单
      searchForm: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      statisticalData: {},
      listLoading: false, // 表格刷新loading
      applicationList: [{ notUpdateNum: 3, updateFailNum: 6, id: '243214124fgdrgd' }],
      updateStatus: 1, // 1 更新失败 2 未更新
      updateRecordPrpos: {},
      spanArr: [], // 一个空的数组，用于存放每一行记录的合并数
      pos: '', // pos是spanArr的索引,需要合并行下标
      spanArr2: [],
      pos2: '',
      spanArr3: [],
      pos3: ''
    };
  },
  computed: {
    ...mapGetters(['areaData', 'schoollist']),
    formatTimeToStr() {
      return formatTimeToStr;
    }
  },
  mounted() {
    this.fetchApplicationList();
  },
  methods: {
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchApplicationList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchApplicationList();
    },
    // 条件查询
    handleSearchFilter(param) {
      console.log(param);
      this.searchForm.pageNum = 1;
      this.searchForm = { ...this.searchForm, ...param };
      this.fetchApplicationList();
    },
    resetInput(param) {
      this.searchForm = { ...this.searchForm, ...param };
      this.fetchApplicationList();
      console.log(param);
    },
    back() {
      this.step = 'history';
      this.fetchApplicationList();
    },
    // 获取应用列表
    fetchApplicationList() {
      this.statisticalList();
      this.listLoading = true;
      this.spanArr = [];
      this.pos = ''; // spanArr的索引
      this.spanArr2 = [];
      this.pos2 = '';
      this.spanArr3 = [];
      this.pos3 = '';
      var option = {
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize,
        campusAppVersionId: this.historyRecordPrpos.campusAppVersionId,
        areaCode: this.searchForm.areaCode,
        schoolCode: this.searchForm.schoolCode,
        typeCode: this.typeCode
      };
      // 区分到教室还是到班级
      if (this.historyRecordPrpos.upgradeType === 1) {
        option = { ...option, classCode: this.searchForm.classCode, gradeCode: this.searchForm.gradeCode };
      } else {
        option = { ...option, buildingId: this.searchForm.buildingId, roomId: this.searchForm.roomId };
      }
      campusVersionsReleaseStatisticPage(option)
        .then(result => {
          this.getSpanArr(result.data.list);
          this.applicationList = result.data.list;
          this.searchForm.total = result.data.total;
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.listLoading = false;
          this.applicationList = [];
          this.searchForm.total = 0;
        });
    },
    // 获取应用列表
    statisticalList() {
      this.listLoading = true;
      var option = {
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize,
        campusAppVersionId: this.historyRecordPrpos.campusAppVersionId,
        campusAppVersionReleaseId: this.historyRecordPrpos.campusAppVersionReleaseId,
        areaCode: this.searchForm.areaCode,
        schoolCode: this.searchForm.schoolCode,
        typeCode: this.typeCode
      };
      // 区分到教室还是到班级
      if (this.historyRecordPrpos.upgradeType === 1) {
        option = { ...option, classCode: this.searchForm.classCode, gradeCode: this.searchForm.gradeCode };
      } else {
        option = { ...option, buildingId: this.searchForm.buildingId, roomId: this.searchForm.roomId };
      }
      campusVersionsReleaseStatistic(option)
        .then(result => {
          this.statisticalData = result.data;
        })
        .catch(err => {
          console.log(err);
          this.statisticalData = {};
        });
    },
    handleUpdateNum(type, row) {
      this.updateStatus = type;
      this.step = 'updateSituation';
      this.updateRecordPrpos = { ...this.historyRecordPrpos,
        areaCode: row.areaCode,
        areaName: (row.provinceName || '') + '/' + (row.cityName || '') + '/' + (row.areaName || ''),
        buildingId: row.buildingId,
        buildingName: row.buildingName,
        classCode: row.classCode,
        className: row.className,
        gradeCode: row.gradeCode,
        gradeName: row.gradeName,
        roomId: row.roomId,
        roomName: row.roomName,
        schoolCode: row.schoolCode,
        schoolName: row.schoolName
      };
    },
    // 合并列
    getSpanArr(data) {
      // data就是我们从后台拿到的数据
      for (let i = 0; i < data.length; i++) {
        // 如果是第一条记录（索引为0），向数组中加入１，并设置索引位置
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0; // spanArr的索引
          this.spanArr2.push(1);
          this.pos2 = 0;
          this.spanArr3.push(1);
          this.pos3 = 0;
        } else {
          // 如果不是第一条记录，则判断它与前一条记录是否相等
          // 根据相同 扣分类别名称 进行合并,根据需要可进行修改
          if (data[i].releaseDate === data[i - 1].releaseDate) {
            // 如果相等，则向spanArr中添入元素0，并将前一位元素＋１，表示合并行数＋１
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
          if (data[i].releaseDate === data[i - 1].releaseDate && data[i].areaCode === data[i - 1].areaCode) {
            this.spanArr2[this.pos2] += 1;
            this.spanArr2.push(0);
          } else {
            this.spanArr2.push(1);
            this.pos2 = i;
          }
          if (data[i].releaseDate === data[i - 1].releaseDate && data[i].areaCode === data[i - 1].areaCode && data[i].schoolCode === data[i - 1].schoolCode) {
            this.spanArr3[this.pos3] += 1;
            this.spanArr3.push(0);
          } else {
            this.spanArr3.push(1);
            this.pos3 = i;
          }
        }
      }
      console.log(this.spanArr);
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        const _row2 = this.spanArr2[rowIndex];
        const _col2 = _row2 > 0 ? 1 : 0;
        return {
          rowspan: _row2,
          colspan: _col2
        };
      }
      if (columnIndex === 2) {
        const _row3 = this.spanArr3[rowIndex];
        const _col3 = _row3 > 0 ? 1 : 0;
        return {
          rowspan: _row3,
          colspan: _col3
        };
      }
      if (columnIndex === 5) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    }
  }
};
</script>
<style lang="scss">

</style>
<style lang="scss" scoped>
.systemUpgrade{
  .tip{
    padding-left: 20px;
  }
  .list-table{
    .sign{
      color: #409eff;
      cursor: pointer;
    }
  }
}
</style>

